export default "__VITE_ASSET__BNqywm_z__"